/* src/app/shared/components/header/header.component.scss */
.header-container {
  background-color: #0E3E32;
  padding: 10px 50px;
}
.header-container .nav-item {
  padding: 5px 10px;
}
.header-container .nav-item .nav-link {
  font-size: 0.85rem;
  color: #FFFFFF;
  font-weight: bolder;
  text-decoration: none;
}
.header-container .nav-item .nav-link:hover,
.header-container .nav-item .nav-link.active {
  text-decoration: underline;
}
.header-container .current-user {
  display: flex;
  align-items: center;
  color: #FFFFFF;
}
.header-container .current-user:before {
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  background: url("./media/user.png") center center no-repeat;
}
.login-link {
  font-size: 0.85rem;
  color: #FFFFFF;
  font-weight: bolder;
}
/*# sourceMappingURL=header.component.css.map */
